import { httpsCallable } from 'firebase/functions';

import { functions } from '../firebase/config';

const getHistoryCallable = httpsCallable(functions, 'getDriverTrackHistory');
const getRideRouteCallable = httpsCallable(functions, 'getRideActualRoute');

const unwrapCallable = async (callable, payload) => {
  const result = await callable(payload);
  return result.data || {};
};

export const getDriverTrackHistory = (filters) => unwrapCallable(getHistoryCallable, filters);

export const getRideActualRoute = (rideId) => unwrapCallable(getRideRouteCallable, { rideId });
